<template>
  <div class="contractors__tenders-wrapper">
    <Spinner v-if="tenderLoading" />
    <div v-else-if="contractorTenders && contractorTenders.length" class="d-contents">
      <FormInput
        id="contractors-search-tenders"
        v-model="searchText"
        :placeholder="$t('Search tenders...')"
      />
      <div class="contractors__tenders">
        <ContractorsTenderCard
          v-for="tender in computedContractorTenders"
          :key="tender.id"
          :tender="tender"
        />
      </div>
    </div>
    <TenderPlug
      v-else
      class="contractors__tenders-plug"
      :title="$t('No tenders')"
      icon="list"
      large
      light
      :description="
        $t(
          'This company hasn’t participated in any tenders yet. Invite it to offer bids for the first time.'
        )
      "
    />
  </div>
</template>

<script>
  import FormInput from '@/components/ui/FormInput';
  import { mapActions, mapState } from 'vuex';
  import ContractorsTenderCard from '@/containers/contractors/add-contractors-modal/ContractorsTenderCard';
  import TenderPlug from '@/components/tender/TenderPlug';
  import Spinner from 'vue-simple-spinner';

  export default {
    name: 'ContractorsTendersTab',
    components: { TenderPlug, ContractorsTenderCard, FormInput, Spinner },
    props: {
      id: {
        type: Number,
        required: true,
      },
    },
    data() {
      return {
        searchText: '',
      };
    },
    computed: {
      ...mapState('contractors', ['contractorTenders', 'tenderLoading']),
      computedContractorTenders() {
        return this.contractorTenders.filter((tender) =>
          tender.tender_name.toLowerCase().includes(this.searchText.toLowerCase())
        );
      },
    },
    methods: {
      ...mapActions('contractors', ['loadContractorTenders']),
    },
    async created() {
      await this.loadContractorTenders(this.id);
    },
  };
</script>
